import API_URL from '../apiconfig';
import {
  ProductDetail,
  ProductPayload,
  ProductUpdatePayload,
} from '../types/catalog';
import axios from './api';
import { invalidateCatalog } from './catalog';

export async function getProduct(productId: string) {
  try {
    const response = await axios.get(`${API_URL}/v1/products/${productId}`);
    return response.data.result as ProductDetail;
  } catch (error) {
    throw new Error('Failed to get product', { cause: error });
  }
}

export async function createProduct(
  businessId: string,
  payload: ProductPayload,
) {
  try {
    const response = await axios.post(`${API_URL}/v1/products`, {
      businessId,
      ...payload,
    });
    await invalidateCatalog();
    return response.data.result as { id: string };
  } catch (error) {
    throw new Error('Failed to create product', { cause: error });
  }
}

export async function updateProduct(
  productId: string,
  businessId: string,
  payload: ProductUpdatePayload,
) {
  try {
    const response = await axios.patch(`${API_URL}/v1/products/${productId}`, {
      businessId,
      ...payload,
    });
    await invalidateCatalog();
    return response.data.result as { id: string };
  } catch (error) {
    throw new Error('Failed to update product', { cause: error });
  }
}
